import { Stack } from "@mui/material";
import CustomPaper from "../../../../_components/CustomPaper";
import DescriptionTypography from "../../../../_components/DescriptionTypography";
import SwitchField from "../../../../_components/SwitchField";

interface Props {
  timeTerm: "Short" | "Long" | "Mid";
  onChange: (value: "Short" | "Long" | "Mid") => void;
}

const Timeframe = ({ timeTerm, onChange }: Props) => {
  return (
    <CustomPaper>
      <Stack direction={"column"} spacing={2} alignItems={"center"}>
        <Stack sx={{ width: "100%" }}>
          <SwitchField
            value={timeTerm}
            postfix={"term"}
            label={"Timeframe"}
            onChange={onChange}
            paramList={["Short", "Mid", "Long"]}
          />
        </Stack>
        <Stack direction={"column"} spacing={1} alignItems={"flex-start"}>
          <DescriptionTypography
            name={"Short term:"}
            description={
              "Ideal for strategies running over 1 to several days, capturing quick market movements."
            }
          />
          <DescriptionTypography
            name={"Mid term:"}
            description={
              "Best suited for strategies active from 1 to several weeks, balancing short- and long-term trends."
            }
          />
          <DescriptionTypography
            name={"Long term:"}
            description={
              "Designed for strategies lasting 1 to several months, focusing on sustained market trends."
            }
          />
        </Stack>
      </Stack>
    </CustomPaper>
  );
};

export default Timeframe;
